import React from 'react';
import { connect } from 'react-redux';
import {
    connectWebsocket,
    setSelectedFeedback,
    setNotificationPermission,
    syncWebsocketFeedbackSubscription
} from '../redux/FeedbackRedux';

class WebsocketConnector extends React.Component {

    componentDidMount() {
        console.log('WebsocketConnector mounted');
        this.props.dispatch(connectWebsocket());
        this.props.dispatch(setSelectedFeedback(this.props.state.selected_feedback));
        this.props.dispatch(syncWebsocketFeedbackSubscription());

        if('Notification' in window && Notification.permission !== 'granted') {
            this.props.dispatch(setNotificationPermission(false));
        } else {
            this.props.dispatch(setNotificationPermission(true));
        }
    }

    render() {
            return true;
        }
    }

function mapStateToProps(state) {
    return { state:state }
}

export default connect(mapStateToProps)(WebsocketConnector)
